//[{name}, {On field Position}, {off field positon}, {Major}]
const importantPeople = [
    ["Arthur Johnson '26", "Prop: 1", "Carebear", "Statistics & English"],
    ["Matt Laws '25", "Hooker: 2", "Captain", "Computer Science"],
    ["Amir Estejab", "Prop: 3", "Alumni Secretary", "Economics & Computer Science"],
    ["Simms Berdy '25", "Lock: 4", "Quartermaster", "Chemistry & German"],
    ["Jake Kirk '27", "Lock: 5", "Rookie", "Economics"],
    ["Eamon Garrity-Rokous '25", "Flanker: 6", "Rookie", "Computer Science"],
    ["William Shepardson '28", "Flanker: 7", "Rookie", "Philosophy"],
    ["James Danziger '25", "8-man: 8", "President", "Political Science & Theater"],
    ["Ignacio Feged '27", "Scrum Half: 9", "Rookie Liason", "Political Economy"],
    ["Kaan Coffin '26", "Fly Half: 10", "Chief", "Biology"],
    ["Will Howe '25", "Inside Center: 12", "Match Secretary", "Physics & Philosophy"],
    ["Zach Bischof '27", "Outside Center: 13", "Gym Rat", "Chemistry"],
    ["Puzant Kiwanian '27", "Wing: 11", "Rookie Liason", "Math"],
    ["Orion Carrera '27", "Wing: 14", "Rookie Liason", "Biology"],
    ["Sam Bentley '28", "Full Back: 15", "Rookie", "Math"],
    ["RJ Acosta '26", "Center", "KGB Foreign Spy", "Economics & Mathematics"],
    ["Dylan Safai '26", "Center", "Rear Admiral", "Political Economy"],
    ["Elijah Adu '27", "Prop", "Treasurer", "Economics & Computer Science"],
    ["Otis Birnbaum '27", "Wing", "Rookie Liason", "Undecided"],
    ["Ronak Dhingra '25", "Lock", "Keeper of the Stairs", "Computer Science & Economics"],
    ["Evan Boyle '25", "Flanker", "Secretary", "Philosophy"],
    ["Bennett Snyder '25", "Wing", "Cartographer", "Economics"],
    ["Will Gallon '25", "Camera Man", "Under Secretary", "Economics"],
    ["Andrew Boies '25", "Wing", "Head of Community", "Philosophy"],
    ["Owen Patrick '25", "Team Masseur", "Head of Community", "Chemistry"],
    ["Zack Le Roy '26", "Wing", "Rookie", "Psychology"],
    ["David Shi '26", "Wing", "Rookie", "Politcal Economy"],
    ["Oskar Webster '26", "Lock", "Head of Advice", "English"],
    ["Michael Pasko '26", "Flanker", "Cardio Bunny", "Political Economy"],
    ["William Chang '28", "Wing", "Rookie", "Undecided"],
    ["Jonathan Hu '28", "Prop", "Rookie", "Computer Sience & Math"],
    ["Sebastian Quadrini '28", "Wing", "Rookie", "Undecided"],
    ["Tristan Kelley '28", "Wing", "Rookie", "Undecided"],
    ["Jason Xia '28", "Wing", "Rookie", "Undecided"],
    ["Guy Juran '28", "Wing", "Rookie", "Undecided"],
    ["Bryce Trent '28", "Prop", "Rookie", "Undecided"],
    ["Ali Griswold '28", "Center", "Rookie", "Undecided"],
    ["Park Edward '28", "Wing", "Rookie", "Undecided"],
    ["Mose Poma '28", "Flanker", "Rookie", "Undecided"],
    ["Johnny Christakos '28", "Hooker", "Rookie", "Undecided"],
    ["Ben Elbaz '28", "Wing", "Rookie", "Undecided"]
    ]
    export default importantPeople;